import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import PropTypes from 'proptypes';
import './LoaderBtn.scss';

export default class AuthWrapper extends Component {
  state = {
    isLoading: true,
    userResponse: null,
  };

  componentDidMount() {
    if (!this.props.hasLoggedOut) {
      Auth.currentUserInfo()
        .then((userResponse) => {
          this.setState({
            isLoading: false,
            userResponse,
          });
          this.props.onFetchingUser();
        })
        .catch(() => {
          this.props.history.push('/');
        });
    }
  }

  render() {
    const { isLoading, userResponse } = this.state;

    if (isLoading) {
      return <div className="loader throbber full-page" />;
    } else if (!userResponse) {
      this.props.history.push('/');
    }
    return <div>{this.props.children}</div>;
  }
}

AuthWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  onFetchingUser: PropTypes.func.isRequired,
  hasLoggedOut: PropTypes.bool.isRequired,
};
